export default "__VITE_ASSET__CWTofNTY__"